import { render, staticRenderFns } from "./Login-v2.vue?vue&type=template&id=a37e950a&scoped=true&"
import script from "./Login-v2.vue?vue&type=script&lang=js&"
export * from "./Login-v2.vue?vue&type=script&lang=js&"
import style0 from "./Login-v2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Login-v2.vue?vue&type=style&index=1&id=a37e950a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37e950a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCol,VForm,VImg,VRow,VTextField})
